<template>
  <div
    :id="id"
    class="
      @375/layout/width:clear
      @480/layout/width:max
      $typography/baseline:solid
      $typography/size:large
      layout/border:3pt
      layout/grid:1
      layout/grid:gap:page
      layout/padding:page
      layout/width:100%
    "
    style="
      --480--layout--width--max: var(--uneven-column-width--main);
    "
    >
    <div v-if="message !== ''">
      <p
        class="
          $typography/weight:bold
          typography
        "
        v-html="message"
        />
    </div>
    <div
      class="
        @375/layout/width:max
        @375/layout/width:min
        @768/layout/margin:bottom
        @768/layout/width:max
        @768/layout/width:min
        layout/margin:bottom
      "
      style="
        --375--layout--width--max:     32.8rem;
        --375--layout--width--min:     25.1rem;
        --768--layout--margin--bottom: 1.7rem;
        --768--layout--width--max:     50rem;
        --768--layout--width--min:     30.5rem;
        --layout--margin--bottom:      1.5rem;
      "
      >
      <signup
        :source="source"
        :flags="flags"
        :placeholder="placeholder"
        :optin="optin"
      />
    </div>
  </div>
</template>

<script>
import signup from "./subscription-signup.vue";

export default {
  components: {
    signup,
  },
  props: ['id', 'source', 'flags', 'placeholder', 'optin', 'message'],
};
</script>
